export default __webpack_public_path__ + "static/media/sala.63baadaf.png";